export const entitySelectorContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px',
  borderRadius: '6px',
  backgroundColor: 'background.default',
  border: '1px solid',
  borderColor: 'divider',
};

export const entitySelectorHelperStyles = {
  display: 'block',
};

export const entitySelectorInputStyles = {
  maxWidth: '360px',
};
